import {apiClient} from '@/services/base/BaseService';

export async function getListFacebookPixel(organizationId: number, shopId: number) {
    const url = `organizations/${organizationId}/shops/${shopId}/facebook-pixels`;
    const response = await apiClient.get(url);
    return response.data.data;
}

export async function deleteFacebookPixel(organizationId: number, shopId: number, id: number) {
    const res = await apiClient.delete(`organizations/${organizationId}/shops/${shopId}/facebook-pixels/${id}`);

    return res.status === 200;
}

export async function createFacebookPixel(organizationId: number, shopId: number, facebookPixelId: string, enabled: boolean, capiToken: string,
                                          isAllPage: boolean, capiEnabled: boolean, productIds: number[], shopCollectionIds: number[]) {
    return await apiClient.post(`organizations/${organizationId}/shops/${shopId}/facebook-pixels`, {
        facebook_pixel_id: facebookPixelId,
        enabled,
        capi_token: capiToken,
        is_all_page: isAllPage,
        capi_enabled: capiEnabled,
        product_ids: productIds,
        shop_collection_ids: shopCollectionIds
    });
}

export async function updateFacebookPixel(organizationId: number, shopId: number, id: number, enabled: boolean, capiToken: string,
                                          isAllPage: boolean, capiEnabled: boolean, productIds: number[], shopCollectionIds: number[]) {
    return await apiClient.post(`organizations/${organizationId}/shops/${shopId}/facebook-pixels/${id}`, {
        enabled,
        capi_token: capiToken,
        is_all_page: isAllPage,
        capi_enabled: capiEnabled,
        product_ids: productIds,
        shop_collection_ids: shopCollectionIds
    });
}

export async function getFacebookPixelById(organizationId: number, shopId: number, id: string) {
    const res = await apiClient.get(`organizations/${organizationId}/shops/${shopId}/facebook-pixels/${id}`);

    return res.data.data;
}

export async function getListFacebookPixelEvents(organizationId: number, shopId: number, date: string, type: string) {
    const res = await apiClient.post(`organizations/${organizationId}/shops/${shopId}/events`, {
        date,
        type
    });

    return res.data.data;
}
